export default __webpack_public_path__ + "static/media/sidebar-toggle.bb2c9438.svg";